import { motion } from 'framer-motion';
import { useGameStore } from '../stores/gameStore';
import { playClick } from '../utils/audio';

export const Settings = () => {
  const {
    soundEnabled,
    colorblindMode,
    wrapMode,
    toggleSound,
    toggleColorblind,
    toggleWrapMode,
    phase,
    closeSettings
  } = useGameStore();

  const open = phase === 'settings';

  if (!open) return null;

  return (
    <div className="lcd-menu">
      <div className="settings-header">
        <div className="settings-title">SETTINGS</div>
      </div>
      <div className="settings-list">
        <SettingRow
          label="Sound"
          description="Retro beeps and tones"
          value={soundEnabled}
          onToggle={() => {
            playClick();
            toggleSound();
          }}
        />
        <SettingRow
          label="High Contrast"
          description="Boost visibility"
          value={colorblindMode}
          onToggle={() => {
            playClick();
            toggleColorblind();
          }}
        />
        <SettingRow
          label="Wrap Mode"
          description="Snake wraps around edges"
          value={wrapMode}
          onToggle={() => {
            playClick();
            toggleWrapMode();
          }}
        />
      </div>
      <motion.button
        className="back-btn"
        whileTap={{ scale: 0.95 }}
        onClick={() => {
          playClick();
          closeSettings();
        }}
      >
        ← Back
      </motion.button>
    </div>
  );
};

interface RowProps {
  label: string;
  description: string;
  value: boolean;
  onToggle: () => void;
}

const SettingRow = ({ label, description, value, onToggle }: RowProps) => {
  return (
    <div className="setting-row">
      <div>
        <div className="setting-label">{label}</div>
        <div className="setting-desc">{description}</div>
      </div>
      <button type="button" onClick={onToggle} className={`toggle ${value ? 'on' : 'off'}`}>
        <div className="toggle-thumb" />
      </button>
    </div>
  );
};

export default Settings;
